import { createPostFetch } from '../../lib/createFetch';
import {
    SendMessageReq,
    SendMessageRes,
} from '../../pages/api/services/sendMessage';

export const sendMessage = createPostFetch<SendMessageReq, SendMessageRes>(
    '/api/services/sendMessage'
);
